import { useQualificationQuestions } from "./useQualificationQuestions";
import { useCurrentUser } from "feature/session/hook/useCurrentUser";

export const useIsQualificationNeeded = () => {
  const qualificationQuestions = useQualificationQuestions();
  const { currentUser } = useCurrentUser();
  if (!qualificationQuestions) return false;
  if (!currentUser) return false;

  return qualificationQuestions.some((question) => !currentUser[question.key]);
};
